'use client';

import TableTooltip from '@/components/Table/components/TableTooltip';
import { useIsClipped } from '@/components/Table/hooks/useIsClipped';
import { cn } from '@/utils/ui-utils';

type Props = {
  value: number | string | null | undefined;
  unit?: string;
  className?: string;
  unitClassName?: string;
};

export const ValueWithUnit = ({ value, unit, className, unitClassName }: Props) => {
  const [ref, isClipped] = useIsClipped<HTMLDivElement>(value);

  if (value === undefined || value === null) {
    return (
      <div className={cn(className)}>
        <span className='text-muted-foreground'>—</span>
      </div>
    );
  }

  const formatted = typeof value === 'number' ? value.toLocaleString('sv-SE') : value;

  const content = (
    <div
      ref={ref}
      className={cn('min-w-0', className)}
    >
      <span>{formatted}</span>
      <span className={cn('text-muted-foreground ml-0.5', unitClassName)}>{unit}</span>
    </div>
  );

  if (isClipped) {
    return <TableTooltip description={<span className='whitespace-nowrap'>{formatted}</span>}>{content}</TableTooltip>;
  }

  return content;
};
